import { frontendURL } from '../../../helper/URLHelper';
import Appointments from './Index.vue';
import viewAppointment from './components/viewAppointment.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';
import { withRealEstateRedirect } from '../../../helper/moduleGuards';

// Real Estate accounts have their own Property Appointments page in this
// nav slot instead (see realEstate.routes.js) — redirect them away from
// the old Branch/Service Appointments URLs rather than showing both.
const appointmentsGuard = withRealEstateRedirect(
  (to, from, next) => subscriptionGuard(to, from, next, store),
  store
);

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/appointments'),
      name: 'appointments',
      component: Appointments,
      meta: {
        permissions: ['administrator', 'restricted', 'service_agent'],
      },
      beforeEnter: appointmentsGuard,
    },
    {
      path: frontendURL('accounts/:accountId/appointment/:appointmentId'),
      name: 'view_appointment',
      component: viewAppointment,
      meta: {
        permissions: ['administrator', 'restricted', 'service_agent'],
      },
      beforeEnter: appointmentsGuard,
    },
  ],
};
